export default __webpack_public_path__ + "static/media/blog-33-image-5.f985eaaa.jpg";